import React, { useState } from "react";
import { AlertCircle, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import Text from "../../containers/Text";
import "../document-cards/DocumentCards.scss";

const GeneralDocumentsCard = ({ documents = [] }) => {
    const [showAlert, setShowAlert] = useState(false);
    const { t } = useTranslation();

    const isValidLink = (link) => {
        if (!link || typeof link !== "string") {
            return false;
        }

        try {
            const url = new URL(link);
            return url.protocol === "http:" || url.protocol === "https:";
        } catch {
            return false;
        }
    };

    const showDocumentAlert = () => {
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3000);
    };

    const handleClick = (doc) => {
        const hasValidFileLink = isValidLink(doc.file_link);

        if (!hasValidFileLink) {
            showDocumentAlert();
            return;
        }

        window.open(doc.file_link, "_blank", "noopener,noreferrer");
    };

    if (!documents || documents.length === 0) {
        return (
            <div className="document-empty-state">
                <FileText className="empty-icon" />
                <Text text={t('no-documents-found')} />
            </div>
        );
    }

    return (
        <>
            <div className="document-cards-container">
                {documents.map((doc) => (
                    <div className="document-card" key={doc.id} onClick={() => handleClick(doc)}>
                        <div className="document-info">
                            <div
                                className="document-icon"
                                style={{ color: isValidLink(doc.file_link) ? "#60BB46" : "#9ca3af" }}
                            >
                                <FileText />
                            </div>

                            <div>
                                <div className="doc-date">{doc.year}</div>
                            </div>
                        </div>

                        <div className="doc-meta-amount">
                            <div className="document-meta">
                                <span className="document-type">
                                    {doc.file_type}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {showAlert && (
                <div className="document-alert-wrapper">
                    <div className="document-alert">
                        <div className="document-alert-box">
                            <div className="alert-icon">
                                <AlertCircle />
                            </div>
                            <div className="alert-text">
                                <h3>{t('document-not-available')}</h3>
                                <p>{t('try-again-later')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default GeneralDocumentsCard;
